<script setup lang="ts">
import { isVNode } from 'vue'
import { Toast, ToastClose, ToastDescription, ToastProvider, ToastTitle, ToastViewport } from '.'
import { useToast } from './use-toast'
import { LucideInfo } from 'lucide-vue-next'

const { toasts } = useToast()
</script>

<template>
  <ToastProvider>
    <div class="flex flex-col-reverse gap-2">
      <Toast
        v-for="toast in toasts"
        :key="toast.id"
        v-bind="toast"
        :class="[
          {
            '!items-center': !toast.description || !String(toast.description).trim().length
          }
        ]"
      >
        <div
          :class="[
            'rounded-full p-[6px]',
            {
              'bg-blue-600': toast.variant === 'default' || !toast.variant,
              'bg-green-500': toast.variant === 'success',
              'bg-orange-600': toast.variant === 'destructive'
            }
          ]"
        >
          <LucideInfo class="h-5 w-5 text-white" />
        </div>
        <div
          :class="[
            {
              'gap-2': toast.description && String(toast.description).trim().length > 0
            },
            'grid'
          ]"
        >
          <ToastTitle v-if="toast.title">
            {{ toast.title }}
          </ToastTitle>
          <template v-if="toast.description">
            <ToastDescription v-if="isVNode(toast.description)">
              <component :is="toast.description" />
            </ToastDescription>
            <ToastDescription v-else>
              {{ toast.description }}
            </ToastDescription>
          </template>
          <ToastClose />
        </div>
        <component :is="toast.action" v-if="toast.action" />
      </Toast>
    </div>
    <ToastViewport />
  </ToastProvider>
</template>
